import { HelmetProvider } from '@dr.pogodin/react-helmet';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLicenseKey } from 'survey-core';
import './App.css';
import AppBody from './AppBody';
import Spinner from './components/Spinner';
import { setAccount } from './store/accountSlice';
import { getAuthenticatedUser } from './store/authSlice';
import { setDomain } from './store/domainSlice';

const App = () => {
  const dispatch = useDispatch();
  const { isLoading, user } = useSelector((state) => state.auth);

  setLicenseKey(import.meta.env.VITE_SURVEY_LICENSE_KEY);

  // Fetch the authenticated user only if not already fetched
  useEffect(() => {
    if (!user) {
      dispatch(setAccount(undefined));
      dispatch(setDomain(undefined));
      dispatch(getAuthenticatedUser());
    }
  }, [dispatch, user]);

  // Handle Mouseflow initialization based on user state
  useEffect(() => {
    if (user && user.email) {
      const userEmail = user.email;
      if (!userEmail.endsWith('@releva.ai')) {
        console.log('Starting Mouseflow for:', userEmail);
        window._mfq = window._mfq || [];
        window._mfq.push(['setVariable', 'email', userEmail]);
        window._mfq.push(['setVariable', 'fullname', `${user.firstName} ${user.lastName}`]);

        // Poll every 2 seconds until Mouseflow is loaded
        const intervalId = setInterval(() => {
          if (window.Mouseflow) {
            window._mfq.push(['start']); // Start Mouseflow tracking
            clearInterval(intervalId); // Clear the interval once Mouseflow is loaded
          } else {
            console.log('Mouseflow not loaded yet, retrying...');
          }
        }, 2000);
      }
    }
  }, [user]); // Only run this effect when 'user' changes

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <HelmetProvider>
      <AppBody authenticatedUser={user} />
    </HelmetProvider>
  );
};

export default App;
